export default {
  methods: {
    addRasterLayer (layer, nextLayerId) {
      const sourceOptions = {
        type: 'raster',
        tileSize: 256
      }

      // Mapbox tileset
      if (layer.mapbox && layer.mapbox.tileset) {
        sourceOptions.url = `mapbox://${layer.mapbox.tileset}`
      // Generic tile endpoint
      } else if (layer.mapbox && layer.mapbox.endpoint) {
        sourceOptions.tiles = [layer.mapbox.endpoint]
      }

      this.map.addLayer({
        id: `${layer.name}`,
        type: 'raster',
        source: sourceOptions,
        paint: {
          'raster-resampling': 'nearest',
          'raster-opacity': 1
        },
        layout: {
          visibility: layer.visible ? 'visible' : 'none'
        }
      }, nextLayerId)
    }
  }
}
